/**
 * @file body.component.tsx
 * @description Компонент тела каталога для Task Manager приложения, который представляет собой тонкую обертку над компонентом Table. Просто передает все пропсы в Table компонент с минимальной стилизацией через CSS класс catalog__content. Фактически дублирует функциональность Table без добавления значимой бизнес-логики или UI улучшений.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['@features/table']
 * @related-files ['src/features/table', 'src/features/catalog/catalog.component.tsx']
 * TODO: избавиться от этого компонента - он является ненужной оберткой над Table
 */

import { ITableHandlers, Table } from '@features/table';
import { ITableItemDTO } from '@src/types';
import { IColumnConfig } from '@src/types/pages';

interface IBody {
    //TODO: add types for columns and row
    rows: ITableItemDTO[];
    columns: IColumnConfig[];
    onRowClick: (row: ITableItemDTO, column: IColumnConfig) => void;
    onScrollToLast: () => void;
    onTableDataUpdated: () => void;
    isCanAddGroups: boolean;
    tableRef: React.RefObject<ITableHandlers>;
}

export const Body = ({
    columns,
    rows,
    onRowClick,
    onScrollToLast,
    onTableDataUpdated,
    isCanAddGroups,
    tableRef
}: IBody) => {
    return (
        <div className="catalog__content w-full h-full flex-1 relative">
            <Table
                items={rows}
                selection="row"
                columns={columns}
                className="clickable-rows"
                onRowClick={onRowClick}
                onScrollToLast={onScrollToLast}
                onTableDataUpdated={onTableDataUpdated}
                isCanAddGroups={isCanAddGroups}
                ref={tableRef}
            />
        </div>
    );
};
